import { render, staticRenderFns } from "./time-slot-bar.vue?vue&type=template&id=2c481634&scoped=true&"
var script = {}
import style0 from "./time-slot-bar.vue?vue&type=style&index=0&id=2c481634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c481634",
  null
  
)

export default component.exports